import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'satellite-dish',
  size: 24,
  node: [
    ['path', { d: 'M18 12a6 6 0 00-6-6', key: '9b1kp8' }],
    [
      'path',
      {
        d: 'M2.824 10.459a8 8 0 0010.717 10.717c.558-.276.623-1.012.183-1.452l-9.448-9.448c-.44-.44-1.176-.375-1.452.183',
        key: '1jwhal',
      },
    ],
    ['path', { d: 'M22 12A10 10 0 0012 2', key: 'm7rnro' }],
    ['path', { d: 'm9 15 4-4', key: '1tjxz5' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name SatelliteDish
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTggMTJhNiA2IDAgMDAtNi02IiAvPgogIDxwYXRoIGQ9Ik0yLjgyNCAxMC40NTlhOCA4IDAgMDAxMC43MTcgMTAuNzE3Yy41NTgtLjI3Ni42MjMtMS4wMTIuMTgzLTEuNDUybC05LjQ0OC05LjQ0OGMtLjQ0LS40NC0xLjE3Ni0uMzc1LTEuNDUyLjE4MyIgLz4KICA8cGF0aCBkPSJNMjIgMTJBMTAgMTAgMCAwMDEyIDIiIC8+CiAgPHBhdGggZD0ibTkgMTUgNC00IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/satellite-dish
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SatelliteDish = createLucideIcon(__iconData);

export default SatelliteDish;
